import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import '../../../Assets/css/landingPage.css';
import DiamondEducation from './DiamondEducation';
import EarthMindLabButton from './EarthMindLabButton';
import ExploreDimondByShap from './ExploreDimondByShap';
import LooseDiamondPage from './LooseDiamondPage';
import OwnEngagmentRing from './OwnEngagmentRing';

const DiamondsStaticPage = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails?.title}</title>
        <meta name="description" content={metaDetails?.description}></meta>
        <meta name="keywords" content={metaDetails?.keywords}></meta>
      </Helmet>
      <div className="dfld_diamond_Section">
        <LooseDiamondPage />
        {/* <EarthMindLabButton /> */}
        <ExploreDimondByShap />
        <OwnEngagmentRing />
        <DiamondEducation />
      </div>
    </>
  );
};

export default DiamondsStaticPage;
